import React from 'react';
import { FadeIn, Section } from './ui';
import { CheckCircle2, XCircle } from 'lucide-react';
export function QualificationSection() {
  const isForYou = ['Sos docente de matemática de secundaria en Argentina', 'Querés dejar de improvisar y tener un sistema claro', 'Tenés alumnos con diagnóstico y no sabés cómo adaptarles las evaluaciones', 'Querés que tus notas sean irrefutables ante padres y directivos', 'Estás cansado de preparar materiales que te llevan horas', 'Querés recuperar tu tiempo los fines de semana'];
  const notForYou = ['Buscás recetas mágicas sin implementar nada', 'No estás dispuesto a cambiar ningún hábito de tu práctica docente', 'Querés un PDF de actividades genéricas para fotocopiar', 'Ya tenés un sistema que funciona perfectamente y no necesitás mejorar nada'];
  return <Section variant="dark" className="!max-w-none" data-id="element-212">
      <div className="max-w-[900px] mx-auto" data-id="element-213">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-214">
          {/* Left Column - Is For You */}
          <FadeIn data-id="element-215">
            <div className="bg-dark-light/50 p-6 md:p-8 rounded-3xl border border-green-900/30 h-full" data-id="element-216">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-6" data-id="element-217">
                Matemática 360 es para vos si:
              </h2>
              <ul className="space-y-4" data-id="element-218">
                {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-219">
                    <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={22} data-id="element-220" />
                    <span className="text-gray-300 text-base" data-id="element-221">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Right Column - Not For You */}
          <FadeIn delay={0.2} data-id="element-222">
            <div className="bg-dark-light/50 p-6 md:p-8 rounded-3xl border border-red-900/30 h-full" data-id="element-223">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-6" data-id="element-224">
                No es para vos si:
              </h2>
              <ul className="space-y-4" data-id="element-225">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-226">
                    <XCircle className="text-red-500 shrink-0 mt-0.5" size={22} data-id="element-227" />
                    <span className="text-gray-400 text-base" data-id="element-228">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}